import { Pipe, PipeTransform } from '@angular/core';
import { TableColumn } from './ui-table-config.interface';

@Pipe({
    name: 'visibleColumns',
    pure: false,
    standalone: true,
})
export class VisibleColumnsPipe implements PipeTransform {
    transform<T>(items: TableColumn<T>[], isVisible = true): TableColumn<T>[] {
        if (!items) {
            return items;
        }
        // filter items array, items which match and return true will be
        // kept, false will be filtered out
        return items.filter(item => item.isVisible === isVisible);
    }
}
